import { fetchWithToken } from "../../interceptors/fetchInterceptor";

import {
  GET_DATA_BY_SEARCH_PARAMS_APP_KNOWLEDGE_VERIFICATION,
  ADD_NEW_DATA_APP_KNOWLEDGE_VERIFICATION,
  SAVE_APP_KNOWLEDGE_VERIFICATION,
  CLEAR_STATE_KNOWLEDGE_VERIFICATION,
  GET_DATA_APP_KNOWLEDGE_VERIFICATION_BY_ID,
  GET_DATA_BY_INPUT_INFO_KNOWLEDGE_VERIFICATION,
  SAVE_DATA_FOR_RERENDER_KNOWLEDGE_VERIFICATION,
  SET_NEED_REWRITE,
} from "../types";
import {
  MAIN_URL,
  PORT_FOR_TRAINING,
  API_GET_DATA_APP_KNOWLEDGE_VERIFICATION,
  API_ADD_APP_KNOWLEDGE_VERIFICATION,
  API_EDIT_APP_KNOWLEDGE_VERIFICATION,
  API_GET_APP_KNOWLEDGE_VERIFICATION,
  API_GET_DATA_BY_INPUT_INFO_KNOW_VERIF,
} from "../../constants/constants";
// import { setOptions } from "../../components/knowledgeTestComponents/appKnowledgeVerification/optionsAppKnowledgeVerification";

export const getDataAppKnowledgeVerificationBySearchParams = (params, page) => {
  return async (dispatch) => {
    const request = await fetchWithToken(
      MAIN_URL + PORT_FOR_TRAINING + API_GET_DATA_APP_KNOWLEDGE_VERIFICATION + "page=" + page + "&size=10",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params),
      },
    ).catch((err) => console.log(err));
    if (request.ok) {
      const data = await request.json();
      for (let item of data.content) {
        item.trainingSelfTraining = item.trainingSelfTraining ? "Самоподготовка" : "Обучение";
      }
      dispatch({
        type: GET_DATA_BY_SEARCH_PARAMS_APP_KNOWLEDGE_VERIFICATION,
        data: data,
      });
    }
  };
};

export function addNewDataAppKnowledgeVerification(data) {
  return {
    type: ADD_NEW_DATA_APP_KNOWLEDGE_VERIFICATION,
    data: data,
  };
}

export function getDataByPersInfo(surname, name, birthDate, programId) {
  return async (dispatch) => {
    const request = await fetchWithToken(
      MAIN_URL +
        PORT_FOR_TRAINING +
        API_GET_DATA_BY_INPUT_INFO_KNOW_VERIF +
        `${surname}/${name}/${birthDate}/${programId}`,
    ).catch((err) => console.log(err));
    if (request.status === 200) {
      const response = await request.json();
      const validatedData = {
        data: {},
        programValid: true,
      };
      response.selfTraining = response.selfTraining ? 1 : 2;
      validatedData.data = response;
      if (response.trainingOrgsName === null) {
        validatedData.programValid = false;
      }
      dispatch({
        type: GET_DATA_BY_INPUT_INFO_KNOWLEDGE_VERIFICATION,
        data: validatedData,
      });
    }
  };
}

export function saveInfoKnowledgeVerification(data, file, mode, id) {
  return async (dispatch) => {
    const formData = new FormData();
    if (!!file) {
      formData.append(`file`, file);
      // delete data.file;
    }
    data.selfTraining = data.selfTraining === 1 ? true : false;
    formData.append("data", JSON.stringify(data));
    let request = null;
    if (mode === "add") {
      request = await fetchWithToken(MAIN_URL + PORT_FOR_TRAINING + API_ADD_APP_KNOWLEDGE_VERIFICATION, {
        method: "POST",
        body: formData,
      });
    }
    if (mode === "edit") {
      request = await fetchWithToken(
        MAIN_URL + PORT_FOR_TRAINING + API_EDIT_APP_KNOWLEDGE_VERIFICATION + String(id),
        {
          method: "POST",
          body: formData,
        },
      );
    }
    if (request.status !== 200) {
      const responseText = await request.text();
      const savingResult = {
        registrationResult: "error",
        appId: responseText.includes("Заявитель") || responseText.includes("Гражданин") ? responseText : "",
      };
      dispatch({
        type: SAVE_APP_KNOWLEDGE_VERIFICATION,
        data: savingResult,
      });
    } else {
      const responseText = await request.text();
      const savingResult = {
        registrationResult: "success",
        appId: responseText,
      };
      dispatch({
        type: SAVE_APP_KNOWLEDGE_VERIFICATION,
        data: savingResult,
      });
    }
  };
}

export function getDataAppById(id, mode, validationKeys) {
  return async (dispatch) => {
    const request = await fetchWithToken(
      MAIN_URL + PORT_FOR_TRAINING + API_GET_APP_KNOWLEDGE_VERIFICATION + id,
    );
    if (request.status === 200) {
      const response = await request.json();
      response.selfTraining = response.selfTraining ? 1 : 2;
      // response.viewFileName = "Testoviy";
      // response?.fotoName;
      response.inspector = response.appUser;
      response.appFileId = response?.fotoId;
      if (mode === "view") {
        for (let item in response) {
          if (validationKeys.includes(item) && response[item]) {
            response[item] = response[item].split("-").reverse().join(".");
          }
        }
      }
      dispatch({
        type: GET_DATA_APP_KNOWLEDGE_VERIFICATION_BY_ID,
        data: response,
      });
    }
  };
}

export function clearState() {
  return {
    type: CLEAR_STATE_KNOWLEDGE_VERIFICATION,
  };
}

export function saveDataForRerender(data) {
  console.log(data);
  return {
    type: SAVE_DATA_FOR_RERENDER_KNOWLEDGE_VERIFICATION,
    data: data,
  };
}

export function setNeedRewrite(needRewrite) {
  return {
    type: SET_NEED_REWRITE,
    data: needRewrite,
  };
}
